import {APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule,} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi,} from '@angular/common/http';
import {RouterModule} from '@angular/router';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {CardModule} from 'primeng/card';
import {ButtonModule} from 'primeng/button';
import {ImageModule} from 'primeng/image';
import {DropdownModule} from 'primeng/dropdown';
import {RadioButtonModule} from 'primeng/radiobutton';
import {CheckboxModule} from 'primeng/checkbox';
import {ToastModule} from 'primeng/toast';
import {MessageService, ConfirmationService} from 'primeng/api';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {InputGroupModule} from 'primeng/inputgroup';
import {InputGroupAddonModule} from 'primeng/inputgroupaddon';
import {InputTextModule} from 'primeng/inputtext';
import {EditorModule} from 'primeng/editor';
import {InputTextareaModule} from 'primeng/inputtextarea';
import {InputMaskModule} from 'primeng/inputmask';
import {FileUploadModule} from 'primeng/fileupload';
import {TableModule} from 'primeng/table';
import {IconFieldModule} from 'primeng/iconfield';
import {InputIconModule} from 'primeng/inputicon';
import {MenuModule} from 'primeng/menu';
import {MenubarModule} from 'primeng/menubar';
import {BadgeModule} from 'primeng/badge';
import {RippleModule} from 'primeng/ripple';
import {AvatarModule} from 'primeng/avatar';
import {AvatarGroupModule} from 'primeng/avatargroup';
import {DialogModule} from 'primeng/dialog';
import {TooltipModule} from 'primeng/tooltip';
import {AppComponent} from './app.component';
import {RatingModule} from 'primeng/rating';
import {AccordionModule} from 'primeng/accordion';
import {DataViewModule} from 'primeng/dataview';
import {CarouselModule} from 'primeng/carousel';
import {TagModule} from 'primeng/tag';
import {routes} from '../routes/app.routes';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {HomeComponent} from './components/home/home.component';
import {ResultadosBuscaComponent} from './components/resultados-busca/resultados-busca.component';
import {MeuPainelComponent} from './components/meu-painel/meu-painel.component';
import {AppTopbarInternoComponent} from './shared/app-topbar-interno/app-topbar-interno.component';
import {AppTopbarComponent} from './shared/app-topbar/app-topbar.component';
import {ModalAvaliacaoComponent} from './shared/modal-avaliacao/modal-avaliacao.component';
import {FooterComponent} from './shared/footer/footer.component';
import {CadastroPromptComponent} from './components/cadastro-prompt/cadastro-prompt.component';
import {PerfilComponent} from './components/perfil/perfil.component';
import {NotFoundComponent} from './components/not-found/not-found.component';
import {EditarPromptComponent} from './components/editar-prompt/editar-prompt.component';
import {NgxLoadingModule} from 'ngx-loading';
import {ConfigService} from './services/config.service';
import {TelaPromptComponent} from './components/tela-prompt/tela-prompt.component';
import {CategoriaComponent} from '../app/components/categoria/categoria.component';
import {UsuariosComponent} from '../app/components/usuarios/usuarios.component';
import {GruposComponent} from '../app/components/grupos/grupos.component';
import {PromptDatabaseComponent} from './components/prompt-database/prompt-database.component';
import {ManualPromptComponent} from './components/manual-prompt/manual-prompt.component';
import {MegaMenuModule} from 'primeng/megamenu';
import {SidebarModule} from 'primeng/sidebar';
import {PanelMenuModule} from 'primeng/panelmenu';
import {ChipModule} from 'primeng/chip';
import {CommonModule} from '@angular/common';
import {ListboxModule} from 'primeng/listbox';
import {MultiSelectModule} from 'primeng/multiselect';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {ProfileUpdateModalComponent} from './components/profile-update-modal/profile-update-modal.component'
import {FiltroComponent} from './shared/filtro/filtro.component';

import {KeycloakAngularModule, KeycloakService} from 'keycloak-angular';
import {initializeKeycloak} from '../routes/initialize-keycloak';
import {AuthInterceptor} from './services/auth.interceptor';

export function initializeApp(
  configService: ConfigService
): () => Promise<void> {
  return () => configService.loadConfig();
}

@NgModule({
  declarations: [
    AppComponent,
    AppTopbarInternoComponent,
    ModalAvaliacaoComponent,
    AppTopbarComponent,
    //LoginComponent,
    FooterComponent,
    HomeComponent,
    ResultadosBuscaComponent,
    MeuPainelComponent,
    PerfilComponent,
    CadastroPromptComponent,
    GruposComponent,
    UsuariosComponent,
    CategoriaComponent,
    FiltroComponent,
    EditarPromptComponent,
    NotFoundComponent,
    ManualPromptComponent,
    TelaPromptComponent,
    PromptDatabaseComponent,
    ProfileUpdateModalComponent


  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    // MatButtonModule,
    // MatCardModule,
    BrowserModule,
    BrowserAnimationsModule,
    ListboxModule,
    MultiSelectModule,
    ReactiveFormsModule,
    KeycloakAngularModule,
    RouterModule.forRoot(routes),
    CardModule,
    DropdownModule,
    RadioButtonModule,
    CheckboxModule,
    ButtonModule,
    ImageModule,
    ToastModule,
    ConfirmDialogModule,
    FormsModule,
    RatingModule,
    CarouselModule,
    ProgressSpinnerModule,
    TagModule,
    FileUploadModule,
    TableModule,
    InputGroupModule,
    InputGroupAddonModule,
    InputTextModule,
    EditorModule,
    InputMaskModule,
    InputTextareaModule,
    IconFieldModule,
    MenuModule,
    DataViewModule,
    MenubarModule,
    RippleModule,
    BadgeModule,
    AvatarModule,
    AvatarGroupModule,
    AccordionModule,
    MegaMenuModule,
    SidebarModule,
    PanelMenuModule,
    ChipModule,
    CommonModule,

    DialogModule,
    TooltipModule,
    InputIconModule,
    NgxLoadingModule,

  ],
 providers: [
  {
    provide: APP_INITIALIZER,
    useFactory: initializeKeycloak,
    deps: [KeycloakService],
    multi: true,
  },
  {
    provide: APP_INITIALIZER,
    useFactory: initializeApp,
    deps: [ConfigService],
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: AuthInterceptor,
    multi: true,
  },
  // ...appConfig.providers,
  MessageService,
  ConfirmationService,
  provideAnimationsAsync(),
  provideHttpClient(withInterceptorsFromDi()),
],
})
export class AppModule {}
